import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { LogIn, Eye, EyeOff } from 'lucide-react';

export default function Login() {
  const { login, tenant } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [brandLogo, setBrandLogo] = useState('/logoudream.png');
  const [brandName, setBrandName] = useState('Udream App');

  useEffect(() => {
    if (tenant) {
      if (tenant.logo_url) setBrandLogo(tenant.logo_url);
      if (tenant.company_name) setBrandName(tenant.company_name + ' App');
    }
  }, [tenant]);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try { await login(username, password); }
    catch (err) { setError('Credenciales inválidas'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 50%, var(--bg-primary) 100%)', padding:20 }}>
      <div style={{ width:'100%', maxWidth:400, padding:'40px 36px', background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:16, boxShadow:'0 8px 40px rgba(0,0,0,0.4)' }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <img src={brandLogo} alt="Logo" style={{ height:64, marginBottom:16 }} onError={e => { e.target.style.display='none'; }} />
          <h1 style={{ fontSize:28, fontWeight:800, color:'var(--text-primary)', letterSpacing:'-0.5px' }}>{brandName}</h1>
          <p style={{ color:'var(--text-muted)', fontSize:14, marginTop:4 }}>Ingresá tus credenciales para continuar</p>
        </div>
        {error && <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:8, padding:'10px 14px', marginBottom:16, color:'#ef4444', fontSize:13 }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label>Usuario</label><input value={username} onChange={e => setUsername(e.target.value)} required /></div>
          <div className="form-group"><label>Contraseña</label>
            <div style={{ position:'relative' }}>
              <input type={showPass ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} required />
              <button type="button" onClick={() => setShowPass(!showPass)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:'var(--text-muted)', cursor:'pointer' }}>
                {showPass ? <EyeOff size={18}/> : <Eye size={18}/>}
              </button>
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading} style={{ width:'100%', marginTop:8 }}>
            <LogIn size={18}/> {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}
